import { api } from './client'

export type StatutoryType =
  | 'GSTR1'
  | 'GSTR3B'
  | 'GSTR9'
  | 'GSTR9C'
  | 'TDS_RETURN'
  | 'TDS_CHALLAN'
  | 'ITR'
  | 'ADVANCE_TAX'
  | 'TAX_AUDIT'
  | 'CMA'
  | 'PT'
  | 'ESI'
  | 'PF'
  | 'ROC_ANNUAL'
  | 'ROC_AOC4'

export interface UpcomingDeadline {
  return_type: StatutoryType
  name: string
  period: string
  due_date: string
  days_left: number
}

export interface DeadlineRequest {
  return_type: StatutoryType
  period: string
  client_type?: string
  turnover_lakhs?: number
  is_audit_case?: boolean
  scheme?: string
  state_code?: string
}

export interface DeadlineResponse {
  return_type: StatutoryType
  period: string
  due_date: string
  original_due_date: string
  is_extended: boolean
  extension_reason?: string
  description: string
}

export interface PenaltyRequest {
  return_type: StatutoryType
  due_date: string
  filing_date?: string
  tax_amount?: number
  is_nil_return?: boolean
}

export interface PenaltyResponse {
  return_type: StatutoryType
  due_date: string
  filing_date?: string
  days_overdue: number
  penalty_amount: number
  interest_amount: number
  total_liability: number
  breakdown: Record<string, unknown>
}

export const statutoryApi = {
  /**
   * Get upcoming statutory deadlines
   */
  upcoming: (days: number = 30): Promise<UpcomingDeadline[]> => {
    return api.get(`/api/v1/statutory/upcoming?days=${days}`)
  },

  /**
   * Calculate due date for a statutory return
   */
  calculateDeadline: (request: DeadlineRequest): Promise<DeadlineResponse> => {
    return api.post('/api/v1/statutory/deadline', request)
  },

  /**
   * Calculate late filing penalty and interest
   */
  calculatePenalty: (request: PenaltyRequest): Promise<PenaltyResponse> => {
    return api.post('/api/v1/statutory/penalty', request)
  },
}
